import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AlertDialog from '../../../components/AlertDialog';

const BasicMenu = ({
  deleteHandler,
  editHandler,
  copyToPersonalHandler,
  copyToVerticalHandler,
  copyToVerticalLabel = 'Copy to Other Vertical',
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const open = Boolean(anchorEl);

  const deleteItemHandler = () => {
    deleteHandler();
    setAnchorEl(null);
  };

  return (
    <div>
      <div>
        <IconButton
          disableRipple={true}
          color="inherit"
          style={{
            border: 0,
            background: isHovered ? 'rgba(0, 0, 0, 0.04)' : 'inherit',
            cursor: 'pointer',
          }}
          size="small"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={(event) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <MoreVertIcon />
        </IconButton>
      </div>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          onClick={() => {
            editHandler();
            setAnchorEl(null);
          }}
        >
          Edit
        </MenuItem>

        {copyToVerticalHandler && (
          <MenuItem
            onClick={() => {
              copyToVerticalHandler();
              setAnchorEl(null);
            }}
          >
            {copyToVerticalLabel}
          </MenuItem>
        )}

        {copyToPersonalHandler && (
          <MenuItem
            onClick={() => {
              copyToPersonalHandler();
              setAnchorEl(null);
            }}
          >
            Copy to Personal Workbench
          </MenuItem>
        )}

        <AlertDialog
          action={deleteItemHandler}
          dialogTitle={`Confirm Deletion`}
          dialogContentText={
            'Are you sure you want to delete this item? This action cannot be undone.'
          }
        >
          <MenuItem>Delete</MenuItem>
        </AlertDialog>
      </Menu>
    </div>
  );
};

export default BasicMenu;
